import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  return (
    <section id="categories" className="w-full py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            热门分类
          </h2>
          <Link
            to="/category/heixan-baoliao"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 hidden sm:block">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}